import Vue from "vue";
import { ACCESS_TOKEN } from "./mutation-types";

export default {
    state: {
        token: "",
        notice: {
            model: false,
            color: "error",
            msg: "",
            timeout: 6000
        }
    },
    mutations: {
        muSetToken(state, token) {
            //console.log("set token:", token);
            state.token = token;
            Vue.ls.set(ACCESS_TOKEN, token, 24 * 3600 * 1000);
        },
        muNotice(state, playload) {
            state.notice.model = true;
            if (typeof playload.type != "undefined") state.notice.color = playload.type;
            if (typeof playload.msg != "undefined") state.notice.msg = playload.msg;
            if (typeof playload.timeout != "undefined") state.notice.timeout = playload.timeout;
        }
    },
    actions: {},
    getters: {
        getToken(state) {
            return state.token;
        }
    }
};
